module.exports = {
    general_error: "Unexpected error",
    hierarchy_duplicites: "Object alredy exist",
    api_communication_error: "Server communication error",
    data_not_found: "Data not found",
    appliances_imprints_not_found: "Any appliance imprints not exist",
    success_removed_imprint: "Appliance imprint successfully removed",
    success_removed_all_imprints: "All appliances successfully removed",
    energy_not_found_for_selected_time: "Energy not found for selected time",
    password_successfully_changed: "Password successfully changed",
    passwords_equal: "Passwords must be different",
    any_assigned_devices: "Any assigned device",
    object_not_empty: "Object isn't empty",
    appliance_imprint_save_success: "Appliance imprint successfully saved",
    error: "Error",
    success_removed_device: "Device successfully removed",
    success: "Success",
    success_removed_appliance: "Appliance successfully removed",
    many_edges: "More than 2 edges detected",
    small_edges: "Less than 2 edges detected",
    any_edge: "No edge detected",
    duplicate_appliance: "Appliance with same name already exists",
    delete_energy_succes: "Energy successfully deleted",
    device_not_responding_or_offline: "Device not responding or is offline",
    lora_settings_successfully_set: "LoRa settings successfully set",
    success_removed_test_case: "Test case successfully removed",
    success_removed_test_profile: "Test profile successfully removed",
    login_credentials_incorrect: "Login credentials incorrect",
    if_want_testing_go_to_section_tesing: "No test results have been saved for this device, if you want testing this device, go to section Testing",
    before_start_testing: "Before start testing process connect testing device to generator",
    before_start_another_testing: "Before start another testing process connect testing device to generator",
    copy_token_to_clipboard: "Copy token to clipboard",
    token_copied: "Token copied",
    no_tokens_available: "No tokens available",
    settings_successfully_saved: "Settings successfully saved",
    choose_disconnector_menu: "Choose disconnector or group in menu",
    current_firmware_version: "Current firmware version",
    available_firmware_version: "Available firmware version",
    starting_upgrade: "Starting upgrade...",
    upgrading: "Upgrading...",
    rebooting: "Rebooting...",
    upgrade_failed: "Upgrade failed",
    upgrade_timeout: "Upgrade timeout. DEVICE NOT STABLE!",
    upgrade_not_available: "Firmware upgrade not available for this device",
    select_image_and_upload_map: "Select image and upload map",
    file_format_not_supported: "File format not supported",
    file_too_large: "File is too large, max allowed size is 1MB",
    image_file_upload_failed: "Upload image file failed",
    loading_image_failed: "Loading image failed",
    please_wait: "Please wait...",
    success_saved_control_map: "Successfully saved control map",
    device_status_change: "Device goes",
    turn_on_relay: "Turn ON",
    turn_off_relay: "Turn OFF",
    notify_anomaly_S_T: "Time duration anomaly between on and off appliance",
    notify_anomaly_S_D: "Runtime duration anomaly",
    notify_anomaly_L_D: "Anomaly at the day level",
    notify_anomaly_L_W: "Anomaly at the week level",
    notify_anomaly_L_M: "Anomaly at the month level",
    notify_anomaly_L_Y: "Anomaly at the year level",
    oauth_cookies_disabled: "Cookies are not enabled in current environment. Google login form not allowed",
    ws_online: "You are online",
    ws_offline: "You are currently offline"
  }